import { Component, OnInit } from '@angular/core';
import { AppService } from '../../../services/app.service';
import { UtilityFunctions } from '../../../utilities/utility-functions';

@Component({
    selector: 'app-avatar',
    templateUrl: './avatar.component.html',
    styleUrls: ['./avatar.component.css', '../../../app.component.css']
})

export class AvatarComponent implements OnInit {

    public subdomain: string = "";
    public userPhotoSourceUrl: string = "";
    public isAvatarVisible: boolean = false;

    public constructor(public appService: AppService) { }

    public ngOnInit(): void {

        this.subdomain = UtilityFunctions.getSubdomain();

        this.userPhotoSourceUrl = this.appService.defaultImageUri;

        this.appService.loggedIn.subscribe((session: any) => {

            this.userPhotoSourceUrl = session.avatarUri;
            this.isAvatarVisible = true;
        });

        this.appService.loggedOut.subscribe((result: any) => {

            this.userPhotoSourceUrl = this.appService.defaultImageUri;
            this.isAvatarVisible = false;
        });
    }

    public toggleTheme = (): void => {

        this.appService.toggleTheme("");
    }

    public goToAdmin = (): void => {

        this.appService.goToSubdomain("admin");
    }

    public logout = (): void => {

        this.appService.logout();
        this.appService.goToSubdomain("www");
    }
}
